const _state = {
    validationMessages: []
}

export const initialState = () => _state

export const state = initialState()